// @flow
import { find, omit } from 'lodash';

import type {
  Doctor, Facility, FacilityGroup, Photo
} from '../types';

export const connectIncludedData = (
  data: Array<Doctor>,
  included: Array<Facility | FacilityGroup | Photo>
): Array<Doctor> =>
  data.map((doctor: Doctor): Doctor => {
    const relationships: Array<['facility' | 'facility_group', any]> = (Object.entries(
      doctor.relationships
    ): any);

    if (!relationships.length) return doctor;

    const relationshipsWithIncludedData: $PropertyType<
      Doctor,
      'relationships'> = relationships.reduce(
        (
          relationshipsObject: any,
          relationshipTuple: ['facility' | 'facility_group', { data: { id: string } }]
        ): $PropertyType<Doctor, 'relationships'> => {
          const relationshipName: string = relationshipTuple[0];
          const relationshipData: { id: string } = relationshipTuple[1].data;
          if (relationshipName === 'consultation_fees') {
            const relatedConsultation_fees: Array<Photo> = Array.isArray(relationshipTuple[1].data)
              ? relationshipTuple[1].data.map(
                ({ id }) => find(included, { id })
              ) : [];
            return {
              ...relationshipsObject,
              [relationshipName]: { data: relatedConsultation_fees }
            };
          }
          const foundRelationshipEntry: ?(Facility | FacilityGroup) = find(included, {
            id: relationshipData.id
          });
          if (!foundRelationshipEntry) return relationshipsObject;

          return {
            ...relationshipsObject,
            [relationshipName]: { data: connectPhotos(foundRelationshipEntry, included) }
          };
        },
        {}
      );

    return { ...doctor, relationships: relationshipsWithIncludedData };
  });

const connectPhotos = (
  companyOrPlace: Facility | FacilityGroup,
  included: Array<Facility | FacilityGroup | Photo>
): Facility | FacilityGroup => {
  const relatedPhotos: Array<Photo> = companyOrPlace.relationships.photos.data.map(
    ({ id }: Photo): Photo => find(included, { id })
  );

  return ({ ...companyOrPlace, relationships: { photos: { data: relatedPhotos } } }: any);
};

export const connectIncludedFacility = (includedData: any) => {
  let finalArray = [];
  for (let i = 0; i < includedData.length; i += 1) {
    if (includedData[i].type === 'facility') {
      finalArray = [...finalArray, includedData[i]];
    } else if (includedData[i].type === 'photo' && includedData[i].attributes.kind === 'listing') {
      for (let j = 0; j < finalArray.length; j += 1) {
        if (finalArray[j].attributes.id === includedData[i].attributes.parent_id) {
          finalArray[j].attributes = {
            ...finalArray[j].attributes,
            ...omit(includedData[i].attributes, 'name')
          };
          break;
        }
      }
    }
  }

  return finalArray;
};
